import Crud from '../views/Area/Crud'
import Entity from '../views/Area/Add'

let routes = {
    path: '/areas',
    permission_name: 'Areas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/areas/add',
            name: 'NewArea',
            permission_name: 'Criar área',
            component: Entity,
            meta: {
                pageTitle: 'area.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'area.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/areas/edit/:id?',
            name: 'EditArea',
            permission_name: 'Editar área',
            component: Entity,
            meta: {
                pageTitle: 'area.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'area.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/areas',
            name: 'list-areas',
            permission_name: 'Listar áreas',
            component: Crud,
            meta: {
                pageTitle: 'area.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'area.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
